export type Environment = {
  name: string;
  baseUrl: string;
  restApiUrl: string;
  cmsApiUrl: string;
  cmsApiKey: string;
  agUrl?: string;
  institutional: string;
  mode?: string;
  stageOneEnabled: boolean;
  publicSearchApiUrl: string;
};

export enum EnvironmentNameEnum {
  DEV = 'dev',
  LOCAL = 'local',
  TEST = 'test',
  HOMOLOG = 'homolog',
  PRODUCTION = 'production',
}

type EnvironmentsMap = Record<EnvironmentNameEnum, Environment>;

const dev: Environment = {
  name: EnvironmentNameEnum.DEV,
  baseUrl: 'http://localhost:8080',
  restApiUrl: 'http://localhost:3000',
  cmsApiUrl: process.env.CMS_API_URL || 'https://cms-test.medprev.app',
  cmsApiKey: process.env.MEDPREV_CMS_API_KEY ?? '',
  agUrl: 'https://agendamento-test.medprev.app',
  institutional: 'https://institucional-test.medprev.online',
  stageOneEnabled: true,
  publicSearchApiUrl: 'https://public-search-api-test.medprev.app/',
};

const local: Environment = {
  name: EnvironmentNameEnum.LOCAL,
  baseUrl: 'http://localhost:8080',
  restApiUrl:
    process.env.MEDPREV_REST_API_URL || 'https://rest-dev-ag.medprev.app',
  cmsApiKey: process.env.MEDPREV_CMS_API_KEY ?? '',
  cmsApiUrl: process.env.CMS_API_URL || 'https://cms-test.medprev.app',
  agUrl: 'https://agendamento-test.medprev.app',
  institutional: 'https://institucional-test.medprev.online',
  stageOneEnabled: true,
  publicSearchApiUrl: 'https://public-search-api-test.medprev.app/',
};

const test: Environment = {
  name: EnvironmentNameEnum.TEST,
  baseUrl: 'https://alpha.medprev.online',
  restApiUrl:
    process.env.MEDPREV_REST_API_URL || 'https://rest-dev-ag.medprev.app',
  cmsApiUrl: 'https://cms-test.medprev.app',
  cmsApiKey: process.env.MEDPREV_CMS_API_KEY ?? '',
  agUrl: 'https://agendamento-test.medprev.app',
  institutional: 'https://institucional-test.medprev.online',
  stageOneEnabled: true,
  publicSearchApiUrl: 'https://public-search-api-test.medprev.app/',
};

const homolog: Environment = {
  name: EnvironmentNameEnum.HOMOLOG,
  baseUrl: 'https://beta.medprev.online',
  restApiUrl:
    process.env.MEDPREV_REST_API_URL || 'https://rest-homolog.medprev.app',
  cmsApiUrl: 'https://cms-hml.medprev.app',
  cmsApiKey: process.env.MEDPREV_CMS_API_KEY ?? '',
  agUrl: 'https://agendamento-homolog.medprev.app',
  institutional: 'https://institucional-homolog.medprev.online',
  stageOneEnabled: true,
  publicSearchApiUrl: 'https://public-search-api-hml.medprev.app/',
};

const production: Environment = {
  name: EnvironmentNameEnum.PRODUCTION,
  baseUrl: 'https://medprev.online',
  restApiUrl: process.env.MEDPREV_REST_API_URL || 'https://rest.medprev.app',
  cmsApiUrl: 'https://cms.medprev.app',
  cmsApiKey: process.env.MEDPREV_CMS_API_KEY ?? '',
  agUrl: 'https://agendamento.medprev.app',
  institutional: 'https://medprev.online',
  stageOneEnabled: true,
  publicSearchApiUrl: 'https://public-search-api.medprev.app/',
};

const environmentsMap: EnvironmentsMap = {
  dev,
  local,
  test,
  homolog,
  production,
};

function getEnvironmentNameFromEnv(): EnvironmentNameEnum {
  return (
    (process.env.ENVIRONMENT_NAME as EnvironmentNameEnum)
    || EnvironmentNameEnum.PRODUCTION
  );
}

export function getEnvironmentNameFromUrl(): EnvironmentNameEnum {
  const url = new URL(window.location.href);

  if (url.hostname.includes('localhost')) {
    return EnvironmentNameEnum.LOCAL;
  }

  if (url.hostname.includes('alpha')) {
    return EnvironmentNameEnum.TEST;
  }

  if (url.hostname.includes('beta')) {
    return EnvironmentNameEnum.HOMOLOG;
  }

  return EnvironmentNameEnum.PRODUCTION;
}

export const getEnvironmentName = (): EnvironmentNameEnum => {
  return typeof window === 'undefined'
    ? getEnvironmentNameFromEnv()
    : getEnvironmentNameFromUrl();
};

export function getEnvironment(): Environment {
  const environmentName
    = typeof window === 'undefined'
      ? getEnvironmentNameFromEnv()
      : getEnvironmentNameFromUrl();
  return environmentsMap[environmentName || EnvironmentNameEnum.PRODUCTION];
}
